module.exports = __webpack_public_path__ + "static/media/profileIcon.6dfeb1d8.svg";